import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { setToken } from "@/lib/api";

export default function AccessEntry() {
  const { token } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    if (token) setToken(token);
    navigate("/mapa", { replace: true });
  }, [token, navigate]);
  return <div className="p-10 text-center text-stone-600" data-testid="access-entry-loading">Validando seu acesso…</div>;
}
